module.exports = __webpack_public_path__ + "bb1.no2.7a4920e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bb1.no2.jpg
// module id = 3oNF
// module chunks = 0